import { computed } from 'vue'
import { useTranslationStore } from '@/stores/translation.store.ts'
import type { TranslationFunction } from '@/locales/types.ts'

export const useTranslations = (prefix?: string) => {
  const translationStore = useTranslationStore()

  const t = computed<TranslationFunction>(() =>
    (key, params) => {
      const fullKey = prefix ? `${prefix}.${key}` : key
      return translationStore.t(fullKey as keyof typeof translationStore.t, params)
    }
  )

  return {
    t: t.value,
  }
}
